jQuery( document ).ready( function( $ ) {
	
	// bbPress seaarch placeholder
	$( '#bbp_search').attr('placeholder', 'Search');

	// html5 media player plugin
	$( 'audio' ).mediaelementplayer();

	// Dropdown search form
	$( '.search-toggle' ).on( 'click', function( e ) {
		e.preventDefault();
		$( '.formdrop' ).toggle();
		$( '.next-show').toggle();
	});

	$('#toggle-chat').on( 'click touchstart', function( e ) {
		e.preventDefault();
		$( '#video-player' ).toggleClass('medium-10 medium-offset-1');
		$( '#chat').toggle();
		this.innerHTML = this.innerHTML === "Show Chat" ? "Hide Chat" : "Show Chat";
	});

} );
